import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AuthService, DocumentService, PageComponent, PageService, ParserService, SettingsService, WindowService} from '@gallaghercp/core-frontend';
import {APP_CONFIG} from '../app.config';
import {ActivatedRoute, Router} from '@angular/router';
import {Meta, Title} from '@angular/platform-browser';
import {TrsService} from '@core-app/services/trs.service';

declare const window: any;

@Component({
    selector: 'core-print',
    templateUrl: './print.component.html',
    standalone: false
})

export class PrintComponent extends PageComponent implements OnInit {

    page: any;
    clientData: any;
    userData: any;

    constructor(
        protected override route: ActivatedRoute,
        protected override router: Router,
        protected override pages: PageService,
        protected override auth: AuthService,
        protected override titleService: Title,
        protected override metaTagService: Meta,
        protected override parser: ParserService,
        protected override settings: SettingsService,
        protected override windowService: WindowService,
        protected override documentService: DocumentService,
        protected override cdr: ChangeDetectorRef,
        protected trsService: TrsService,
    ) {
        super(
            route,
            router,
            pages,
            titleService,
            metaTagService,
            auth,
            parser,
            settings,
            windowService,
            documentService,
            cdr,
        )
    }

    override ngOnInit() {
        this.page = window.pageData ? window.pageData : false;

        this.clientData = window.clientData ? window.clientData : false;
        this.auth.serviceProvider = {id: 0, name: 'Print', configuration: this.clientData};

        this.userData = window.userData ? window.userData : false;
        this.auth.user = this.userData;

        if (!this.page || !this.page.name) {
            this.router.navigate(['/']);
        }

        this.pages.setCurrentPage(this.page);
        this.page$ = this.page;
        this.titleService.setTitle(this.page.name + ' | ' + APP_CONFIG.appName);

        this.setHeightClass();
    }

    setHeightClass() {
        const parentEl = document.getElementById('site-content');
        const timeRewardsNotShown = !this.trsService.isTimeRewardsShownForClient();
        const oneFinancialRewardsPageShown = !this.trsService.isFinancialRewardPageTwoNeededForPdf();
        const twoFinancialRewardsPagesShown = this.trsService.isFinancialRewardPageTwoNeededForPdf();
        const oneAddedExtrasPageShown = !this.trsService.isAddedExtrasPageTwoNeededForPdf();
        const twoAddedExtrasPageShown = this.trsService.isAddedExtrasPageTwoNeededForPdf();

        if (parentEl) {
            if (timeRewardsNotShown &&
                (oneFinancialRewardsPageShown && twoAddedExtrasPageShown ||
                    oneFinancialRewardsPageShown && oneAddedExtrasPageShown ||
                    twoFinancialRewardsPagesShown && oneAddedExtrasPageShown) ||
                !timeRewardsNotShown && oneFinancialRewardsPageShown && oneAddedExtrasPageShown) {
                parentEl.classList.add('height-for-first-7-pages');
            } else {
                parentEl.classList.add('height-for-first-9-pages');
            }
        }
    }

}
